module.exports = __webpack_public_path__ + "img/brasao-branco-horizontal.7515a2c6.svg";